<div class="container">
  <main id="content" class="error-container" role="main">
    <div class="row">
      <div class="col-xl-4 col-md-6 col-xs-10 offset-xl-4 offset-md-3 offset-xs-1">
        <div class="error-container">
          <h1 class="error-code">404</h1>
          <p class="error-info">
            Opps, it seems that this page does not exist.
          </p>
          <p class="error-help mb">
            If you are sure it should, search for it.
          </p>
          <form (ngSubmit)="searchResult()" method="get">
            <div class="form-group">
              <input class="form-control input-no-border" type="text" placeholder="Search Pages">
            </div>
            <button type="submit"  class="btn btn-inverse">
              Search <i class="fa fa-search text-warning ml-xs"></i>
            </button>
          </form>
        </div>
      </div>
    </div>
  </main>

  <footer class="page-footer">
    2016 &copy; Sing. Admin Dashboard Template.
  </footer>
</div>
